import { API_LOCATION_URL } from 'infrastructure/config';
import { IPostInput, IPostResponse, IInviteUserClient } from 'interfaceAdapter/gatewaySchemas/IInviteUserClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/invite/user`;

export class InviteUserClient implements IInviteUserClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, email, invitation_type } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ email, invitation_type });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
